import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=5ebb68bc&scoped=true"
import script from "./AnnouncementView.vue?vue&type=script&lang=js"
export * from "./AnnouncementView.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementView.vue?vue&type=style&index=0&id=5ebb68bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb68bc",
  null
  
)

export default component.exports